var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsExpandDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4C22.75 2.89543 21.8546 2 20.75 2H16.75C15.6454 2 14.75 2.89543 14.75 4V8C14.75 9.10457 15.6454 10 16.75 10H20.75C21.8546 10 22.75 9.10457 22.75 8V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2197 11.4697C12.5126 11.1768 12.9874 11.1768 13.2803 11.4697C13.5732 11.7626 13.5732 12.2374 13.2803 12.5303L7.81066 18L11.2803 21.4697C11.4948 21.6842 11.559 22.0068 11.4429 22.287C11.3268 22.5673 11.0533 22.75 10.75 22.75H2.75C2.33579 22.75 2 22.4142 2 22V14C2 13.6967 2.18273 13.4232 2.46299 13.3071C2.74324 13.191 3.06583 13.2552 3.28033 13.4697L6.75 16.9393L12.2197 11.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExpandDownLeft);
export default __webpack_public_path__ + "static/media/arrows-expand-down-left.8a26ce4e0c298b791839b2ef0cbc1384.svg";
export { ForwardRef as ReactComponent };